import { Logo } from "@/components/Logo";
import { Wordmark } from "@/components/Logo";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-line bg-ink">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center text-cream mb-4">
            <Wordmark height={26} />
          </div>
          <p className="text-ash text-sm max-w-xs leading-relaxed">
            A private home for indie songwriters, artists & producers. Quality over quantity — three songs, real people.
          </p>
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.18em] text-ash flex flex-col gap-3">
          <span className="text-cream">Navigate</span>
          <Link to="/auth" className="hover:text-gold transition-colors w-fit">Create profile</Link>
          <a href="/#how" className="hover:text-gold transition-colors w-fit">How it works</a>
          <a href="/#noai" className="hover:text-gold transition-colors w-fit">No-AI policy</a>
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.18em] text-ash flex flex-col gap-3">
          <span className="text-cream">The fine print</span>
          <Link to="/terms" className="hover:text-gold transition-colors w-fit">Terms of Use</Link>
          <Link to="/privacy" className="hover:text-gold transition-colors w-fit">Privacy Policy</Link>
          <a href="/#noai" className="hover:text-gold transition-colors w-fit">No-AI policy</a>
        </div>
      </div>
      <div className="border-t border-line py-5 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-ash/60">
        © 2026 WriterHaus — The home for indie music makers.
      </div>
    </footer>
  );
}
